const yesNoConductFinancialTransactionsWithAdvisor = {
    yes: 'Oui',
    no: 'Non',
};

export default yesNoConductFinancialTransactionsWithAdvisor;
